import noUiSlider from 'nouislider';
import Swiper, { Pagination, Thumbs, Navigation, Autoplay } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';

import 'nouislider/dist/nouislider.css';

Swiper.use([Pagination, Thumbs, Navigation, Autoplay ]);

if($('.lightbox-swiper').length > 0) {
    const lightboxSlider = new Swiper('.lightbox-swiper', {
        loop: true,
        slidesPerView: 1,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
    });
    $('.lightbox-opener').on('click', function() {
        $('#lightbox').fadeIn();
        lightboxSlider.slideTo(parseInt($(this).attr('data-key')) + 1);
        $('.lightbox-background').on('click', function() {
            $('#lightbox').fadeOut();
        });
        $('#lightbox-closer').on('click', function() {
            $('#lightbox').fadeOut();
        });
    });
}

if($('.fordon-swiper').length > 0) {
    const thumbSwiper = new Swiper('.thumb-swiper', {
        loop: true,
        slidesPerView: "auto",
        spaceBetween: 10,
        watchSlidesProgress: true,
    });
    const fordonSwiper = new Swiper('.fordon-swiper', {
        loop: true,
        thumbs: {
          swiper: thumbSwiper,
        },
        autoplay: {
          delay: 6000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
    });
}

if($('.read-more').length > 0) {
    $('.read-more').each(function(){
        $(this).click(function(){
            // $(this).parent().toggleClass('car-card--open');

            $(this).parent().find('.text--short').toggle();
            $(this).parent().find('.text--long').slideToggle();
        });
    });
}

$('li a[data-featherlight]').each(function() {
    const attr = $(this).data('featherlight');
    const item = $(this);
    item.featherlight($(attr), {
        afterClose: () => {
            item.focus();
        }
    });
})

if($('.toggle').length > 0) {
    $('.toggle').each(function(){
        $(this).click(function(){
            $(this).parent().toggleClass('hidden');
        });
    });
}

if(document.getElementById('finance') != undefined &&
    (document.getElementById('finance_months_value') != undefined ||
    document.getElementById('finance_deposit-payment_value') != undefined ||
    document.getElementById('finance_residual-debt_value') != undefined)
) {

    const finance_button = document.querySelector('#finance-btn');
    const finance_section = document.querySelector('#finance');
    if(finance_button) {
        finance_button.addEventListener("click", e => {
            e.preventDefault();
            finance_section.scrollIntoView({behavior: "smooth", block: "center"});
        });
    }

    var finance_nper = document.getElementById('finance_months');
    var finance_deposit = document.getElementById('finance_deposit-payment');
    var finance_residual = document.getElementById('finance_residual-debt');
    var price_ele = document.querySelectorAll('.monthly-cost');
    var rate_ele = document.getElementById('e-interest-rate');

    var total_loan_ele = document.querySelectorAll('.total-loan');
    var down_payment_ele = document.querySelectorAll('.down-payment');
    var total_months_ele = document.querySelectorAll('.total-months');
    var remaining_debt_ele = document.querySelectorAll('.remaining-debt');

    const startMonths = parseInt(document.getElementById('finance_months_value').innerHTML);
    const minMonths = parseInt(document.getElementById('min_nper').value);
    const maxMonths = parseInt(document.getElementById('max_nper').value);

    const startDeposit = parseInt(document.getElementById('finance_deposit-payment_value').innerHTML);
    const minDeposit = parseInt(document.getElementById('min_deposit').value);
    const maxDeposit = parseInt(document.getElementById('max_deposit').value);

    const startResidue = parseInt(document.getElementById('finance_residual-debt_value').innerHTML);
    const minResidue = parseInt(document.getElementById('min_residue').value);
    const maxResidue = parseInt(document.getElementById('max_residue').value);

    var rate = parseFloat(document.getElementById('ranta').value/100)/12;
    var aviavgift = parseInt(document.getElementById('aviavgift').value);
    var upplaggningsavgift = parseInt(document.getElementById('upplaggningsavgift').value);

    var compDown, compResidual;

    var price = parseFloat(document.getElementById('price').innerHTML.replaceAll('kr', '').replaceAll('ex moms', '').replaceAll(' ', '')); // Totalpriset för bilen
    var depositPercent = startDeposit/100; // Kontatinsats i procent
    var depositPayment = price * depositPercent; // Kontantinsats i kr
    var residualDebt = startResidue/100; // Restskuld i procent
    var pv = -(price - depositPayment); // Nuvarande värde (alltså antalet kronor som behöver lånas. totalpriset - kontantinsattsen)
    var fv = price * residualDebt; // Framtida värde
    var nper = startMonths; // Antalet månader
    var e_rate = (((Math.pow(calc_rate(nper, (pmt(rate, nper, pv, fv) + aviavgift).toFixed(0), pv + upplaggningsavgift, fv)+1, 12))-1)*100).toFixed(2);
    var total_loan = 0;

    const update_total_loan = (total_loan) => {
        total_loan_ele.forEach(item => {
            item.innerHTML = total_loan;
        });
    };
    const update_price = (price) => {
        price_ele.forEach(item => {
            item.innerHTML = price;
        });
    }
    const update_months = (months) => {
        total_months_ele.forEach(item => {
            item.innerHTML = months;
        });
    }
    const update_down_payment = (price) => {
        down_payment_ele.forEach(item => {
            item.innerHTML = price;
        });
    }

    noUiSlider.create(finance_nper, {
        start: [minMonths],
        connect: [true, false],
        range: {
            'min': minMonths,
            'max': maxMonths
        },
        step: 1,
        format: {
            to: (v) => parseFloat(v).toFixed(0),
            from: (v) => parseFloat(v).toFixed(0)
        },
        pips: { mode: 'count', values: 2 }
    });
    finance_nper.noUiSlider.on('update', function (values, handle) {
        document.getElementById('finance_months_value').innerHTML = values[handle];
        nper = parseInt(values[handle]);
        let price_to_show = (pmt(rate, nper, pv, fv) + aviavgift).toFixed(0).toLocaleString('sv');
        if(price_to_show.length === 5) {
            price_to_show = price_to_show.slice(0, 2) + ' ' + price_to_show.slice(2);
        }
        if(price_to_show.length === 4) {
            price_to_show = price_to_show.slice(0, 1) + ' ' + price_to_show.slice(1);
        }

        update_price(price_to_show);

        rate_ele.innerHTML = (((Math.pow(calc_rate(nper, (pmt(rate, nper, pv, fv) + aviavgift).toFixed(0), pv + upplaggningsavgift, fv)+1, 12))-1)*100).toFixed(2);
        e_rate = (((Math.pow(calc_rate(nper, (pmt(rate, nper, pv, fv) + aviavgift).toFixed(0), pv + upplaggningsavgift, fv)+1, 12))-1)*100).toFixed(2);

        calculate_total_cost((pmt(rate, nper, pv, fv) + aviavgift).toFixed(0), nper);

        update_months(values[handle]);
    });

    noUiSlider.create(finance_deposit, {
        start: [minDeposit],
        connect: [true, false],
        range: {
            'min': minDeposit,
            'max': maxDeposit
        },
        step: 5,
        format: {
            to: (v) => parseFloat(v).toFixed(0),
            from: (v) => parseFloat(v).toFixed(0)
        },
        pips: { mode: 'count', values: 2 }
    });
    finance_deposit.noUiSlider.on('update', function (values, handle) {
        if(depositPercent != parseFloat(values[handle])/100) {
            document.getElementById('finance_deposit-payment_value').innerHTML = values[handle];
            depositPercent = parseFloat(values[handle])/100;

            depositPayment = price * depositPercent;
            pv = -(price - depositPayment);

            let price_to_show = (pmt(rate, nper, pv, fv) + aviavgift).toFixed(0).toLocaleString('sv');
            if(price_to_show.length === 5) {
                price_to_show = price_to_show.slice(0, 2) + ' ' + price_to_show.slice(2);
            }
            if(price_to_show.length === 4) {
                price_to_show = price_to_show.slice(0, 1) + ' ' + price_to_show.slice(1);
            }

            update_price(price_to_show);

            rate_ele.innerHTML = (((Math.pow(calc_rate(nper, (pmt(rate, nper, pv, fv) + aviavgift).toFixed(0), pv + upplaggningsavgift, fv)+1, 12))-1)*100).toFixed(2);
            e_rate = (((Math.pow(calc_rate(nper, (pmt(rate, nper, pv, fv) + aviavgift).toFixed(0), pv + upplaggningsavgift, fv)+1, 12))-1)*100).toFixed(2);

            if(depositPercent + residualDebt > 1) { // Justerar restskulden ifall de skulle krocka
                finance_residual.noUiSlider.set(100 - values[handle]);
            }

            const dp = price * parseFloat(values[handle])/100;
            total_loan = parseInt(price - dp);

            update_total_loan(total_loan.toLocaleString('sv'));
            calculate_total_cost((pmt(rate, nper, pv, fv) + aviavgift).toFixed(0), nper);

            update_down_payment(parseInt(dp).toLocaleString('sv'))
        }
    });

    noUiSlider.create(finance_residual, {
        start: [minResidue],
        connect: [true, false],
        range: {
            'min': minResidue,
            'max': maxResidue
        },
        step: 1,
        format: {
            to: (v) => parseFloat(v).toFixed(0),
            from: (v) => parseFloat(v).toFixed(0)
        },
        pips: { mode: 'count', values: 2 }
    });
    finance_residual.noUiSlider.on('update', function (values, handle) {
        if(residualDebt != parseInt(values[handle])/100){
            document.getElementById('finance_residual-debt_value').innerHTML = values[handle];
            residualDebt = values[handle];

            residualDebt = parseInt(residualDebt)/100;
            fv = price * residualDebt;

            let price_to_show = (pmt(rate, nper, pv, fv) + aviavgift).toFixed(0).toLocaleString('sv');
            if(price_to_show.length === 5) {
                price_to_show = price_to_show.slice(0, 2) + ' ' + price_to_show.slice(2);
            }
            if(price_to_show.length === 4) {
                price_to_show = price_to_show.slice(0, 1) + ' ' + price_to_show.slice(1);
            }

            update_price(price_to_show);

            rate_ele.innerHTML = (((Math.pow(calc_rate(nper, (pmt(rate, nper, pv, fv) + aviavgift).toFixed(0), pv + upplaggningsavgift, fv)+1, 12))-1)*100).toFixed(2);
            e_rate = (((Math.pow(calc_rate(nper, (pmt(rate, nper, pv, fv) + aviavgift).toFixed(0), pv + upplaggningsavgift, fv)+1, 12))-1)*100).toFixed(2);
            calculate_total_cost((pmt(rate, nper, pv, fv) + aviavgift).toFixed(0), nper);

            if(depositPercent + residualDebt > 1) { // Justerar kontantinsatsen ifall de skulle krocka
                var cur = finance_deposit.noUiSlider.get();
                finance_deposit.noUiSlider.set(cur - 5);
            }

            const resiudual = (parseInt(price) * parseFloat(values[handle]/100)).toLocaleString('sv');
            remaining_debt_ele.forEach(item => {
                item.innerHTML = resiudual;
            });
        }
    });

    // Trigga uppdatering av värden direkt vid inladdning av sidan
    setTimeout(() => {
        finance_nper.noUiSlider.set(startMonths);
        finance_deposit.noUiSlider.set(startDeposit);
        finance_residual.noUiSlider.set(startResidue);
    }, 300);
}

/**
 * Copy of Excel's PMT function.
 * Credit: https://gist.github.com/maarten00/23400873d51bf2ec4eeb
 *
 * @param rate_per_period       The interest rate for the loan.
 * @param number_of_payments    The total number of payments for the loan in months.
 * @param present_value         The present value, or the total amount that a series of future payments is worth now;
 *                              Also known as the principal.
 * @param future_value          The future value, or a cash balance you want to attain after the last payment is made.
 *                              If fv is omitted, it is assumed to be 0 (zero), that is, the future value of a loan is 0.
 * @param type                  Optional, defaults to 0. The number 0 (zero) or 1 and indicates when payments are due.
 *                              0 = At the end of period
 *                              1 = At the beginning of the period
 * @returns {number}
 */
function pmt(rate_per_period, number_of_payments, present_value, future_value, type = 0) {
    future_value = typeof future_value !== 'undefined' ? future_value : 0;
    type = typeof type !== 'undefined' ? type : 0;

    if(rate_per_period != 0.0){
        // Interest rate exists
        var q = Math.pow(1 + rate_per_period, number_of_payments);
        return -(rate_per_period * (future_value + (q * present_value))) / ((-1 + q) * (1 + rate_per_period * (type)));

    } else if(number_of_payments != 0.0){
        // No interest rate, but number of payments exists
        return -(future_value + present_value) / number_of_payments;
    }

    return 0;
}
/**
 * @link https://gist.github.com/kucukharf/677d8f21660efaa33f72
 * @author Burak Arslan @kucukharf http://www.github.com/kucukharf
 * @license
 * Copyright (c) 2010-2018 Burak Arslan
 * Licensed under Creative Commons (CC) license
 * @usage RATE(periods, payment, present, future, type, guess)
 */

function calc_rate(periods, payment, present, future, type, guess) {
    guess = (guess === undefined) ? 0.01 : guess;
    future = (future === undefined) ? 0 : future;
    type = (type === undefined) ? 0 : type;

    // Set maximum epsilon for end of iteration
    var epsMax = 1e-10;

    // Set maximum number of iterations
    var iterMax = 10;

    // Implement Newton's method
    var y, y0, y1, x0, x1 = 0,
      f = 0,
      i = 0;
    var rate = guess;
    if (Math.abs(rate) < epsMax) {
      y = present * (1 + periods * rate) + payment * (1 + rate * type) * periods + future;
    } else {
      f = Math.exp(periods * Math.log(1 + rate));
      y = present * f + payment * (1 / rate + type) * (f - 1) + future;
    }
    y0 = present + payment * periods + future;
    y1 = present * f + payment * (1 / rate + type) * (f - 1) + future;
    i = x0 = 0;
    x1 = rate;
    while ((Math.abs(y0 - y1) > epsMax) && (i < iterMax)) {
      rate = (y1 * x0 - y0 * x1) / (y1 - y0);
      x0 = x1;
      x1 = rate;
        if (Math.abs(rate) < epsMax) {
          y = present * (1 + periods * rate) + payment * (1 + rate * type) * periods + future;
        } else {
          f = Math.exp(periods * Math.log(1 + rate));
          y = present * f + payment * (1 / rate + type) * (f - 1) + future;
        }
      y0 = y1;
      y1 = y;
      ++i;
    }
    return rate;
}

function calculate_total_cost(monthly_cost, months) {
    const total_cost_ele = document.querySelectorAll('.total-cost');
    total_cost_ele.forEach(item => {
        item.innerHTML = (monthly_cost * months).toLocaleString('sv');
    })
}
